import { render } from 'preact';
import './styles/tokens.css';
import './styles/layout.css';
import { App } from './App';

// 빌드 마커(asset 해시 갱신용). 오염된 캐시 URL 을 새 해시로 교체.
document.documentElement.dataset.build = '2026-07-30-1';

render(<App />, document.getElementById('app')!);
